import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import type { FC } from "react";
import { APP_CONTENT_WIDTH_WITHOUT_PADDING } from "src/constants/layout";
import type { PartnerConfig } from "src/constants/partnerConfig";
import { openPartnerContinueUrl } from "src/constants/partnerConfig";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import Translate from "src/ui/components/Translate/Translate";

const Section = styled.section`
  width: 100%;
  max-width: ${APP_CONTENT_WIDTH_WITHOUT_PADDING}px;
  margin: 0 auto;
  padding: var(--space-xl) var(--space-md);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
`;

const Heading = styled.h1`
  margin: 0;
`;

const Steps = styled.ol`
  margin: 0;
  padding-left: 1.25em;
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  li {
    margin: 0;
  }
`;

const PartnerSsoConnect: FC<{ partner: PartnerConfig }> = ({ partner }) => {
  const { headingRef } = useFocusHeading();
  const variables = { partner: partner.displayName };

  return (
    <Section>
      <Heading className="as-h4-large" ref={headingRef} {...getHeadingProps()}>
        <Translate msg="partnerSsoConnect.title" />
      </Heading>
      <p className="m0 color-c-80">
        <Translate msg="partnerSsoConnect.description" variables={variables} />
      </p>
      <p className="m0 color-c-80">
        <Translate msg="partnerSsoConnect.howItWorks" />
      </p>
      <Steps className="color-c-80">
        <li>
          <Translate
            msg="partnerSsoConnect.step.continue"
            variables={variables}
          />
        </li>
        <li>
          <Translate
            msg="partnerSsoConnect.step.signIn"
            variables={variables}
          />
        </li>
        <li>
          <Translate msg="partnerSsoConnect.step.return" />
        </li>
      </Steps>
      <Button theme="sunrise" onPress={() => openPartnerContinueUrl(partner)}>
        <Translate msg="partnerSsoConnect.button" variables={variables} />
      </Button>
    </Section>
  );
};

export default PartnerSsoConnect;
